import type {TurnItem, UserMessageItem} from '../../types/events'
import {TOOLS_HIDDEN_FROM_TIMELINE} from '../../constants/tool-names'
import {isInjectedSource} from '../command-helpers'
import {isDeniedResult} from './permission-constants'

/**
 * Whether a UserMessageItem would produce visible rendered output.
 * Mirrors the null-return checks in UserMessage.tsx.
 */
export function isUserMessageVisible(msg: UserMessageItem): boolean {
  if (msg.isDismissed) return false
  if (isInjectedSource(msg.source)) return false
  if (!msg.content?.trim()) return false
  return true
}

/**
 * Whether a TurnItem would produce visible rendered output.
 * Mirrors the null-return checks in each item renderer so the model can determine
 * visibility without rendering.
 */
export function isTurnItemVisible(item: TurnItem): boolean {
  switch (item.kind) {
    case 'assistant_text':
    case 'subagent_group':
      return true

    case 'tool_call':
      return !TOOLS_HIDDEN_FROM_TIMELINE.has(item.toolCall.toolName)

    case 'permission':
      // Only denied permissions render; approved/pending render null
      if (!item.completedEvent) return false
      return isDeniedResult(item.completedEvent.data.result?.kind)

    case 'ask_user':
    case 'elicitation':
    case 'plan_approval':
      return item.completedEvent !== null

    case 'remote_steerable':
      return item.enabled

    default:
      return false
  }
}
